"use strict";
/**
 * Pure helpers for highlighting matched search terms inside arbitrary
 * strings. Kept free of any React / DOM imports so they can be reused by
 * any component (Metrics admin, AI Hub Dashboard list view, etc.) and
 * tested in isolation.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatcherTerms = exports.textMatchesSearch = exports.buildSearchMatcher = exports.getSearchTerms = exports.escapeSearchTerm = void 0;
var SPECIAL_REGEX_CHARS = /[.*+?^${}()|[\]\\]/g;
exports.escapeSearchTerm = function (value) {
    return value.replace(SPECIAL_REGEX_CHARS, '\\$&');
};
exports.getSearchTerms = function (searchText) {
    return searchText.trim().split(/\s+/).filter(Boolean);
};
/**
 * Build a single case-insensitive matcher that captures any of the
 * (whitespace-separated) terms in `searchText`. Returns `null` when the
 * search text is empty so callers can short-circuit cheap "no search"
 * paths.
 */
exports.buildSearchMatcher = function (searchText) {
    var terms = exports.getSearchTerms(searchText);
    if (terms.length === 0) {
        return null;
    }
    return new RegExp("(" + terms.map(function (term) { return exports.escapeSearchTerm(term); }).join('|') + ")", 'ig');
};
exports.textMatchesSearch = function (value, matcher) {
    if (!matcher) {
        return true;
    }
    matcher.lastIndex = 0;
    return matcher.test(value);
};
/**
 * Returns the lower-cased list of terms encoded in a matcher built by
 * `buildSearchMatcher`. Useful for renderers that need to know which
 * split parts to wrap in a highlight element.
 */
exports.getMatcherTerms = function (matcher) {
    return matcher.source
        .replace(/^\(|\)$/g, '')
        .split('|')
        .map(function (term) { return term.replace(/\\(.)/g, '$1').toLowerCase(); });
};
